module.exports = __webpack_public_path__ + "assets/img/tiger2.bd4feddb.jpg";